import type { SettableOfferRequestReportStatus } from '@houzy/schemas/offer-request-management';
import type { PartnerCockpitOfferRequest } from '@houzy/schemas/partner-cockpit/offer-requests';
import Stack from '@mui/material/Stack';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { OfferRequestsEmptyState } from './OfferRequestsEmptyState';
import { OpenOfferRequestCard } from './OpenOfferRequestCard';

export type OpenOfferRequestsListProps = {
    offerRequests: PartnerCockpitOfferRequest[];
    onSelectOfferRequest?: (offerRequest: PartnerCockpitOfferRequest) => void;
    onStatusChange?: (offerRequest: PartnerCockpitOfferRequest, status: SettableOfferRequestReportStatus) => void;
    // Forwarded clock anchor so stories/tests keep relative times deterministic.
    now?: Date;
};

export function OpenOfferRequestsList({
    offerRequests,
    onSelectOfferRequest,
    onStatusChange,
    now,
}: OpenOfferRequestsListProps): ReactElement {
    const { t } = useTranslation();

    if (offerRequests.length === 0) {
        return <OfferRequestsEmptyState title={t('OFFER_REQUESTS.EMPTY.TITLE')} hint={t('OPEN_REQUESTS.EMPTY.HINT')} />;
    }

    return (
        <Stack spacing={1} component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
            {offerRequests.map((req) => (
                <li key={req.uuid}>
                    <OpenOfferRequestCard
                        offerRequest={req}
                        now={now}
                        onClick={onSelectOfferRequest ? (): void => onSelectOfferRequest(req) : undefined}
                        onStatusChange={onStatusChange ? (status): void => onStatusChange(req, status) : undefined}
                    />
                </li>
            ))}
        </Stack>
    );
}
